// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"lT-z","inlineTitle":"mT-z","sponsoredAdsWrapper":"nT-z","marketplaceRecosWrapper":"oT-z"};